module.exports = __webpack_public_path__ + "img/aghk-bus-default.3263c9a9.svg";